

import { Card, CardBody, Button } from '@material-tailwind/react'
import React from 'react'

const Except1 = () => {
  return (
    <div className='except1-container'>
        <div className='except1'>
            <div className='except1-inner'>
                <Card className='w-full p-8 sm:w-1/2 sm:p-16'>
                    <CardBody>
                    <h4>At Language Helpers, We believe in clear and </h4>
                    <h2>Precise Communication</h2>
                    <p>
                        Let us take the anxiety out of cross-cultural interactions and help you focus on what matters most. 
                        Because when people understand each other, opportunities grow, and possibilities become endless.
                    </p>
                    <a href="/about"><Button className='bg-[#382356]' size="md">Read More</Button></a>

                    </CardBody>
                </Card>
            </div>
        </div>
    </div>
  )
}

export default Except1